export default __webpack_public_path__ + "static/media/nl.d29ced80.svg";